import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Settings, Home, BarChart3, Award, Users } from 'lucide-react';
import logo from '../../assets/images/logo.png';

const Header = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActivePath = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <header style={{
      background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
      boxShadow: '0 4px 12px rgba(59, 130, 246, 0.15)',
      padding: '12px 0',
      marginBottom: '0'
    }}>
      <div className="container">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 16px'
        }}>
          <Link 
            to="/" 
            style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '1.4rem',
              fontWeight: '700',
              color: 'white',
              textDecoration: 'none',
              gap: '12px'
            }}
          >
            <img 
              src={logo} 
              alt="QAME Logo" 
              style={{
                height: '32px',
                width: 'auto',
                borderRadius: '4px'
              }}
            />
            QAME
          </Link>

          <nav style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Link 
              to="/" 
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                color: location.pathname === '/' ? 'white' : 'rgba(255,255,255,0.8)',
                textDecoration: 'none',
                fontWeight: '500',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '0.9rem',
                background: location.pathname === '/' ? 'rgba(255,255,255,0.2)' : 'transparent',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (location.pathname !== '/') {
                  e.target.style.background = 'rgba(255,255,255,0.1)';
                  e.target.style.color = 'white';
                }
              }}
              onMouseLeave={(e) => {
                if (location.pathname !== '/') {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgba(255,255,255,0.8)';
                }
              }}
            >
              <Home size={14} />
              <span style={{ display: window.innerWidth > 768 ? 'inline' : 'none' }}>Home</span>
            </Link>

            {user ? (
              <>
                <Link
                  to="/admin/participants"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: isActivePath('/admin/participants') ? 'white' : 'rgba(255,255,255,0.8)',
                    textDecoration: 'none',
                    fontWeight: '500',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    background: isActivePath('/admin/participants') ? 'rgba(255,255,255,0.2)' : 'transparent',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <Users size={14} />
                  <span style={{ display: window.innerWidth > 768 ? 'inline' : 'none' }}>Participants</span>
                </Link>
                <Link
                  to="/admin/certificate-templates"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: isActivePath('/admin/certificate-templates') ? 'white' : 'rgba(255,255,255,0.8)',
                    textDecoration: 'none',
                    fontWeight: '500',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    background: isActivePath('/admin/certificate-templates') ? 'rgba(255,255,255,0.2)' : 'transparent',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <Award size={14} />
                  <span style={{ display: window.innerWidth > 768 ? 'inline' : 'none' }}>Certificates</span>
                </Link>
                <Link 
                  to="/admin" 
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: isActivePath('/admin') ? 'white' : 'rgba(255,255,255,0.8)',
                    textDecoration: 'none',
                    fontWeight: '500',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    background: isActivePath('/admin') ? 'rgba(255,255,255,0.2)' : 'transparent',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (!isActivePath('/admin')) {
                      e.target.style.background = 'rgba(255,255,255,0.1)';
                      e.target.style.color = 'white';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActivePath('/admin')) {
                      e.target.style.background = 'transparent';
                      e.target.style.color = 'rgba(255,255,255,0.8)';
                    }
                  }}
                >
                  <Settings size={14} />
                  <span style={{ display: window.innerWidth > 768 ? 'inline' : 'none' }}>Admin</span>
                </Link>
                <button 
                  onClick={logout}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    background: 'rgba(255,255,255,0.15)',
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.3)',
                    borderRadius: '6px',
                    padding: '8px 12px',
                    fontSize: '0.85rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    marginLeft: '8px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(255,255,255,0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255,255,255,0.15)';
                  }}
                >
                  <LogOut size={14} />
                  <span style={{ display: window.innerWidth > 640 ? 'inline' : 'none' }}>
                    {user.username}
                  </span>
                </button>
              </>
            ) : (
              <Link 
                to="/admin/login" 
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  color: 'white',
                  textDecoration: 'none',
                  fontWeight: '500',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '0.9rem',
                  background: 'rgba(255,255,255,0.15)',
                  border: '1px solid rgba(255,255,255,0.3)',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.25)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.15)';
                }}
              >
                Login
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;